/* eslint-disable vue/require-v-for-key */
<template>
  <div class="user-admin">
    <b-card-body>
      <b-form submit="save">
        <input id="user-id" type="hidden" v-model="user.id" />
        <b-row class="rowUsername">
          <b-col md="6" sm="12">
            <b-form-group
              id="user-userName"
              :label="$t('login')"
              label-for="user-userName"
              v-if="user.id == 0"
              >
              <b-form-input
                @keydown="removeSpecialCharacters"
                class="input-pentagro"
                id="user-userName"
                type="text"
                name="validateUsername"
                v-model="user.userName"
                v-validate="{
                  alpha_dash: true,
                  required: user.id == 0 ? true : false,
                  min: 4,
                  max: 20,
                }"
                :state="validateState('validateUsername')"
                aria-describedby="validateUsername-feedback"
                :data-vv-as="$t('login')"
                :placeholder="$t('informe-o-nome-de-usuario')"
              />
              <b-form-invalid-feedback id="validateUsername-feedback">{{
                veeErrors.first("validateUsername")
              }}</b-form-invalid-feedback>
            </b-form-group>
            <div v-else class="txtLogin">
              <b>{{ $t('login') }} {{ user.userName }}</b>
            </div>
          </b-col>

          <b-col md="6" sm="12">
            <b-form-group
              id="user-productionUnit"
              :label="$t('unidade-0')"
              label-for="productionUnit-select"
            >
              <select
                class="form-control  "
                id="productionUnit-select"
                v-model="user.unitId"    
                :disabled="this.editing"              
              >
                <option
                  v-for="unit in this.productionUnitList"
                  :key="unit.id"
                  :value="unit.id"                  
                >
                  {{ unit.name }}
                </option>
              </select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" sm="12">
            <b-form-group :label="$t('nome-completo')" label-for="user-name">
              <b-form-input
                class="input-pentagro"
                id="user-name"
                type="text"
                name="validateName"
                v-model="user.name"
                v-validate="{ required: true, min: 4 }"
                :state="validateState('validateName')"
                aria-describedby="validateName-feedback"
                data-vv-as="nome completo"
                :placeholder="$t('informe-o-nome-completo-do-usuario')"
              />
              <b-form-invalid-feedback id="validateName-feedback">{{
                veeErrors.first("validateName")
              }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col md="6" sm="12">
            <b-form-group :label="$t('e-mail')" label-for="user-email">
              <b-form-input
                class="input-pentagro"
                id="user-email"
                type="email"
                name="validateEmail"
                v-model="user.email"
                :placeholder="$t('informe-o-e-mail-do-usuario')"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row style="align-items: center">
          <b-col md="6" sm="12">
            <b-form-group
              id="user-profileId"
              :label="(user.edited == 1 ? 'Perfil: (Personalizado)' : 'Perfil:')"
              label-for="profileId-select"
            >
              <select
                class="form-control"
                id="profileId-select"
                v-model="user.profileId"
                @change="onChange($event)"
              >
                <option
                  v-for="prof in this.profiles"
                  :key="prof.id"
                  :value="prof.id"
                >
                  {{ prof.description }}
                </option>
              </select>
            </b-form-group>
          </b-col>
          <b-modal
            id="confirmChangeProfile"
            ok-variant="danger"
            :ok-title="$t('yes')"
            :cancel-title="$t('no')"
            @ok="loadProfile(profileIdTransient)"
            @cancel="reset()"
            >{{ $t('o-perfil-selecionado-possui-permissoes-personalizadas-deseja-alterar-o-perfil') }}</b-modal
          >
          <b-col class="mb-3" md="2" sm="2">
            <label for="loginExpiration">{{ $t('tempo-de-token') }}</label>
            <b-form-spinbutton
              class="spinbutton-pentagro"
              id="loginExpiration"
              v-model="user.loginExpiration"
              min="1"
              :max="this.tokenMaxTime"
              step="1"
            ></b-form-spinbutton>
          </b-col>
          <b-col class="mb-3" md="2" sm="2" v-if="isSearchLimited">
            <label for="limitSearchAdherence">{{ $t('limit-adherence-search') }}</label>
            <section class="limitSearchContainer">
              <button type="button" @click="customChangeSearchLimit('down')">
                <svg viewBox="0 0 16 16" width="1em" height="1em" focusable="false" role="img" aria-label="dash" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-dash b-icon bi"><g transform="translate(8 8) scale(1.25 1.25) translate(-8 -8)"><path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"></path></g></svg>
              </button>
              <input
                id="limitSearchAdherence"
                v-model="searchLimitInterval"
                min="1"
                max="365"
                type="number"
                />
              <button type="button" @click="customChangeSearchLimit('up')">
                <svg viewBox="0 0 16 16" width="1em" height="1em" focusable="false" role="img" aria-label="plus" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-plus b-icon bi"><g transform="translate(8 8) scale(1.25 1.25) translate(-8 -8)"><path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"></path></g></svg>
              </button>
            </section>
          </b-col>
          <b-col>
            <b-form-checkbox
              v-model="user.receiveAutonomousWarning"
              name="check-button-receiveAutonomousWarning"
              switch
            >
              {{ $t('receber-alertas') }} </b-form-checkbox>
            <!-- </b-col>
          <b-col md="2" sm="2"> -->
            <b-form-checkbox
              v-model="user.handleOccurrences"
              name="check-button-handleOccurrences"
              switch
            >
              {{ $t('tratar-ocorrencias') }} </b-form-checkbox>

            <b-form-checkbox
              v-model="user.disabled"
              name="disable"
              class="disable"
              switch
            >
              <b>{{ $t('desabilitar-usuario') }}</b>
            </b-form-checkbox>
          </b-col>
        </b-row>

        <!-- <b-row v-show="mode === 'save'"> -->
        <b-row v-show="user.id == 0">
          <b-col md="6" sm="12">
            <b-form-group :label="$t('senha')" label-for="user-userPassword">
              <b-form-input
                class="input-pentagro"
                id="user-password"
                type="password"
                name="validatePassword"
                v-model="user.userPassword"
                v-validate="{
                  required: user.id == 0 ? true : false,
                  min: 4,
                  max: 20,
                }"
                :state="validateState('validatePassword')"
                aria-describedby="validatePassword-feedback"
                :data-vv-as="$t('senha')"
                :placeholder="$t('informe-a-senha-do-usuario')"
              />
              <b-form-invalid-feedback id="validatePassword-feedback">{{
                veeErrors.first("validatePassword")
              }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col md="6" sm="12">
            <b-form-group
              :label="$t('confirmacao-de-senha')"
              label-for="user-confirm-password"
            >
              <b-form-input
                class="input-pentagro"
                id="user-confirm-password"
                type="password"
                name="validateConfirmPassword"
                v-model="user.confirmPassword"
                v-validate="{
                  required: user.id == 0 ? true : false,
                  min: 4,
                  max: 20,
                  is: user.userPassword,
                }"
                :state="validateState('validateConfirmPassword')"
                aria-describedby="validateConfirmPassword-feedback"
                :data-vv-as="$t('confirmacao-de-senha-0')"
                :placeholder="$t('informe-a-senha-do-usuario')"
              />
              <b-form-invalid-feedback id="validateConfirmPassword-feedback">{{
                veeErrors.first("validateConfirmPassword")
              }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>

        <span v-if="isSearchLimited && user.profileId == 1" id="warningLimitSearch">*Aviso: Usuários com o perfil 'Administrativo' não terão suas buscas limitadas pela permissão 'Limitar Buscas de Aderências'.</span>
        <hr />

        <template>
          <p>
            {{ $t('permissoes') }} <img
              src="@/assets/allPermissionsTrue.png"
              class="iconPermission"
              :alt="$t('habilitar-todas-as-permissoes')"
              :title="$t('habilitar-todas-as-permissoes')"
              @click="changeAllPemissions(true)"
            />
            <img
              src="@/assets/allPermissionsFalse.png"
              class="iconPermission"
              :alt="$t('desabilitar-todas-as-permissoes')"
              :title="$t('desabilitar-todas-as-permissoes')"
              @click="changeAllPemissions(false)"
            />
          </p>
          <b-card-body 
            class="containerScreen"
            v-if="user.profileId != 0"
            >

            <b-row class="boxContainer"
              xl="3" lg="6" md="6" sm="6"
              v-for="area in this.areasList" :key="area"
              >
                  <p>
                    <b>{{ area }}:</b>
                  </p>
                  <b-card class="boxPermission boxAdmPerm">
                    <div>
                      <template
                        v-for="(value, name, index) in user.jsonPermissions"
                      >
                      <b-form-checkbox
                        v-if="value.area == area && value.permission && (isPentagroUser || !rtoRestrictedActions.includes(value.action))"
                        :key="name + index"
                        v-model="value.allowed"
                        @change="(event) => ChangePermissionStatus(event, name)"
                        switch
                      >
                        {{ value.permission }}
                      </b-form-checkbox>
                      </template>
                    </div>
                  </b-card>           
            </b-row>
          </b-card-body>
        </template>

        <b-row class="groupButton">
          <div>
            <img
              src="@/assets/apagar.png"
              :alt="$t('limpar-formulario-de-cadastro')"
              style="margin-left: 30px; height=38px"
              :title="$t('limpar-formulario-de-cadastro')"
              @click="$bvModal.show('confirmUserFormRestore')"
            />
            <img
              src="@/assets/salvar.png"
              :alt="$t('salvar')"
              style="margin-left: 30px; height=38px"
              :title="$t('salvar')"
              @click="save"
            />
          </div>
        </b-row>
      </b-form>
    </b-card-body>
    <b-modal
      id="confirmUserFormRestore"
      ok-variant="danger"
      :ok-title="$t('yes')"
      :cancel-title="$t('no')"
      @ok="resetUser"
      >{{ $t('confirmar-a-limpeza-do-formulario') }}</b-modal
    >
    <hr />
    
    <label>Pesquisar usuário:</label>
    <br>
    <input type="text" class="searchBar" v-model="searchText" placeholder="Procurar por nome ou e-mail...">

    <b-card>
      {{ $t('usuarios-cadastrados-users-length', [users.length]) }} <b-table
        hover
        responsive
        striped
        small
        :items="filteredUsers"
        :fields="fields"
        sort-by="id"
      >
        <template v-slot:cell(actions)="row">
          <img
            src="@/assets/editarusuario.png"
            :alt="$t('editar-usuario')"
            style="max-height: 25px"
            :title="$t('editar-usuario-0')"
            @click="loadUser(row.item.id, row.item.unitId, row.item.system)"
          />
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { urlMainAPI, showError, defaultSuccess } from "@/global";
import axios from "axios";

export default {
  name: "UserAdmin",
  
  watch: {
    "user.unitId"() {
      this.user.productionUnitId = this.productionUnit;
    },

    "searchLimitInterval"(value){
      this.searchLimitInterval = Number(value) > 365 ? 365 : value = "" || Number(value) < 1 ? 1 : value;
    }
  },
  data: function () {
    return {
      mode: "save",
      productionUnitList: [],
      productionUnit: 1,
      switchList: [],
      areasList: [],
      loadingUser: false,
      editing: false,
      user: {
        id: 0,
        userName: "",
        userPassword: "",
        name: "",
        email: "",
        improveTeamMember: false,
        handleOccurrences: false,
        receiveAutonomousWarning: false,
        loginExpiration: 2,
        disabled: false,
        system: null,
        unitId: null,
        profileId: 0,
        profileDescription: "",
        jsonPermissions: {},
      },
      profile: {
        id: 0,
        description: "",
        receiveAutonomousWarning: false,
        tokenExpiration: 0,
        handleOccurrences: false
      },
      users: [],
      profiles: [],
      profileIdTransient: {},
      jsonPermissionsTemp: {},
      userProfileIdTemp: 0,
      fields: [
        { key: "name", label:this.$t('nome') , sortable: true },
        { key: "profileDescription", label:this.$t('perfil'), sortable: true },
        { key: "email", label:this.$t('e-mail-0'), sortable: true },
        {
          key: "disabled",
          label: this.$t('status-1'),
          sortable: true,
          formatter: (value) => (value == false ? this.$t('ativo'): this.$t('desabilitado')),
        },
        { key: "actions", label: this.$t('acoes-0') },
      ],
      isSearchLimited:false,
      searchLimitInterval:365,
      searchText: "",
      // Permissoes do RTO que so o usuario Pentagro pode ver/gerenciar.
      rtoRestrictedActions: ["rtoconfigbase", "rtoconfigavancada", "rtoconfigurar"],
    };
  },

  methods: {
    customChangeSearchLimit(operation){
      if(operation != undefined && operation != ""){
        if(operation == "down") this.searchLimitInterval = Number(this.searchLimitInterval) - 1;
        else if( operation == "up") this.searchLimitInterval = Number(this.searchLimitInterval) + 1; 
      }
    },

    ChangePermissionStatus(event, name) {
      this.user.jsonPermissions[name].allowed = event;

      if(this.user.jsonPermissions[name] && this.user.jsonPermissions[name].action == "limitarbuscaaderencias"){
        this.isSearchLimited = event;
      }
    },
    
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },

    resetForm() {
      this.$nextTick(() => {
        this.$validator.reset();
      });
    },

    loadProductionUnits() {
      const url = `${urlMainAPI}/getproductionunitlist`;
      axios
        .get(url)
        .then((res) => {
          this.productionUnitList = res.data.productionUnitList;
        })
        .catch();
    },

    loadProfiles() {
      const url = `${urlMainAPI}/getprofiles`;
      axios
        .get(url)
        .then((res) => {
          this.profiles = res.data;
          this.profiles.unshift({
            id: 0,
            description: this.$t('selecione-um-perfil'),
          });
        })
        .catch();
    },

    changeProductionUnitList() {},

    loadUsers() {
      const url = `${urlMainAPI}/getusers`;
      axios
        .get(url)
        .then((res) => {
          this.users = res.data;
          this.users.forEach((element) => {
            element.profileDescription = this.profiles.find(
              (x) => x.id == element.profileId
            ).description;
            if (element.edited) {
              element.profileDescription = `${element.profileDescription} (Personalizado)`
            }
          });
        })
        .catch();
    },

    resetUser() {
      this.loadUser(0, 1, this.system);
      this.loadUsers();
    },

    reset() {
      this.user.jsonPermissions = JSON.parse(JSON.stringify(this.jsonPermissionsTemp));
      this.user.profileId = this.userProfileIdTemp;
    },

    onChange(event) {
      if(event.target.value != 0 && event.target.value != this.userProfileIdTemp && this.user.edited == 1){
        this.profileIdTransient = event.target.value
        this.$bvModal.show("confirmChangeProfile")
      } else {
        this.loadProfile(event.target.value);
      }
      this.loadingUser = false;
    },

    save() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          showError(this.$t('campos-com-preenchimento-obrigatorio'));
          return;
        }

        if(this.user.profileId == 0){
          showError(this.$t('o-campo-perfil-e-obrigatorio'));
          return;
        }

        var md5 = require("md5");
        if (this.user.id == 0) {
          this.user.userPassword = md5(this.user.userPassword);
          this.user.userPassword = window.btoa(
            JSON.stringify(this.user.userPassword)
          );
          this.user.confirmPassword = md5(this.user.confirmPassword);
          this.user.confirmPassword = window.btoa(
            JSON.stringify(this.user.confirmPassword)
          );
          delete this.user.confirmPassword;
        } else {
          delete this.user.confirmPassword;
          delete this.user.userPassword;
        }
        this.user.name = this.trimString(this.user.name);
        this.user.userName = (this.trimString(this.user.userName));

        if(!this.user.email) {
          this.user.email = " ";
        } else {
          this.user.email = this.trimString(this.user.email);
        }

        this.user.searchLimit = this.searchLimitInterval;
        
        axios.post(`${urlMainAPI}/saveuser`, this.user)
          .then((res) => {
            defaultSuccess(res.data);
            this.resetUser();
          })
          .catch();
      });
    },

    async loadProfile(profileId, mode = "save") {
      const url = `${urlMainAPI}/getuserprofilebyid/${profileId}`;
      await axios
        .get(url)
        .then((res) => {
          this.profile = res.data;
          this.user.jsonPermissions = JSON.parse(this.profile.jsonPermissions);
          this.user.loginExpiration = this.profile.tokenExpiration;
          this.user.handleOccurrences = this.profile.handleOccurrences;
          this.user.receiveAutonomousWarning =
            this.profile.receiveAutonomousWarning;
          
          if(this.user.jsonPermissions.limitarbuscaaderencias && this.user.jsonPermissions.limitarbuscaaderencias.allowed && this.user.jsonPermissions.limitarbuscaaderencias.allowed == true)
            this.isSearchLimited = true;
        
          this.searchLimitInterval = this.profile.searchLimit;


          
          let distinctList = new Set();
          for (let key in this.user.jsonPermissions) {
            // eslint-disable-next-line no-extra-boolean-cast
            if (!!this.user.jsonPermissions[key].area) {
              distinctList.add(this.user.jsonPermissions[key].area);
            }
          }
          this.areasList = Array.from(distinctList).sort();

          this.mode = mode;
        })
        .catch();
    },

    async loadUser(userId, unitId, system, mode = "save") {
      const url = `${urlMainAPI}/getuserbyid/${system}/${unitId}/${userId}`;
      await axios
        .get(url)
        .then((res) => {
          this.isSearchLimited = false;
          this.user = res.data;
          
          this.user.jsonPermissions = JSON.parse(this.user.jsonPermissions);

          let distinctList = new Set();
          for (let key in this.user.jsonPermissions) {
            // eslint-disable-next-line no-extra-boolean-cast
            if (!!this.user.jsonPermissions[key].area) {
              distinctList.add(this.user.jsonPermissions[key].area);
            }
          }
          this.areasList = Array.from(distinctList).sort();

          if (this.user.id !== 0) {
            this.editing = true
            this.jsonPermissionsTemp = JSON.parse(JSON.stringify(this.user.jsonPermissions));
            this.userProfileIdTemp = this.user.profileId;

            if(this.user.jsonPermissions.limitarbuscaaderencias && this.user.jsonPermissions.limitarbuscaaderencias.allowed && this.user.jsonPermissions.limitarbuscaaderencias.allowed == true)
              this.isSearchLimited = true;

            this.searchLimitInterval = this.user.searchLimit;

            defaultSuccess(this.$t('usuario-selecionado-com-sucesso'));
            this.loadingUser = true;
          } else {
            this.editing = false
          }
          this.resetForm();
          this.mode = mode;
        })
        .catch();
    },

    trimString(text) {
      return text.trim();
    },

    changeAllPemissions(status) {
      Object.keys(this.user.jsonPermissions).forEach(
        (item) => {
          // Permissoes de RTO so sao alteradas pelo usuario Pentagro.
          if(!this.isPentagroUser && this.rtoRestrictedActions.includes(this.user.jsonPermissions[item].action)){
            return;
          }

          this.user.jsonPermissions[item].allowed = status

          if(this.user.jsonPermissions[item].action == "limitarbuscaaderencias"){
            this.isSearchLimited = status
          }
        }
      );
    },

    removeSpecialCharacters() {
      this.user.userName = this.user.userName.replace(/[^0-9a-zA-Z _-]+/g, "");
    },

  },

  created() {
    this.system = this.$store.state.system;
    this.tokenMaxTime = this.$store.state.tokenMaxTime;
    this.$validator.localize("pt_BR");
    this.loadUser(0, 1, this.system);
    this.loadUsers();
    this.loadProductionUnits();
    this.loadProfiles();
  },

  computed: {
    isPentagroUser() {
      const userName = this.$store.state.user && this.$store.state.user.UserName;
      return !!userName && userName.toLowerCase() === "pentagro";
    },
    filteredUsers() {
      if(!this.searchText){
        return this.users;
      }

      const terms = this.searchText.toLowerCase().trim().split(/\s+/);

      return this.users.filter(user => 
        {
          const name  = (user.name || "").toLowerCase();
          const email = (user.email || "").toLowerCase();

          return terms.every( term => name.includes(term) || email.includes(term) );
        }
      )
    }
  }
};
</script>

<style>
.custom-control-label,
td > img {
  cursor: pointer;
}
</style>

<style scoped>
.searchBar{
  width: 100%;
  height: 35px;
  margin-bottom: 15px;
  padding: 5px;
  font-size: 1rem;
  border: 1px solid #ff5f00;
  border-radius: 3px;
}


.iconPermission {
  max-height: 45px;
  margin: 0px 5px 0px 0px;
  cursor: pointer;
}

.btAllPermission {
  margin-left: 10px;
  margin-right: 10px;
}

.boxPermission {
  min-width: 290px;
  height: 320px;
  overflow: auto;
  margin: 10px 0px;
}

.groupButton {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 0;
}

.groupButton img {
  cursor: pointer;
}

.rowUsername {
  align-items: center;
  margin-bottom: 20px;
}

.disable {
  color: rgb(178, 64, 0);
}

img {
  max-height: 45px;
}

.txtLogin {
  font-size: 140%;
}

@media only screen and (max-width: 768px) {
  .boxAdmPerm {
    min-height: 180px;
  }

  .txtLogin {
    margin-bottom: 20px;
  }
}



.boxContainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between; 
  margin-right: 4px;
  margin-left: 1px; 
  flex-direction: column;
  padding: 0.5rem;
  width: 380px; 
}

.card-body {
    padding: 0.25rem;
}

.containerScreen{
    flex: 1 1 auto;
    min-height: 1px;
    padding: 1.25rem;
    display: flex;
    flex-wrap: wrap;
    padding: 10p;
    box-shadow: 0 0 3px #0003;
    width: 100%;

}

.groupButton {
  margin-top: 16px;
  margin-right: 18px

}

#limitSearchAdherence{
  text-align: center;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  width: 100%;
  height: 100%;
  border: none;
}

#limitSearchAdherence::-webkit-outer-spin-button,
#limitSearchAdherence::-webkit-inner-spin-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin: 0;
}

.limitSearchContainer{
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid #ff5f00;
  border-radius: 3px;
  color: #495057;
}

.limitSearchContainer input:focus{
  
  border: none !important;
  box-shadow: none !important;
}

.limitSearchContainer:focus-within {
  box-shadow: 0px 0px 5px #ff5f00;
}

.limitSearchContainer button{
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0 8px;
}

.limitSearchContainer button:first-child{
  border-right: 1px solid #dee2e6;
}
.limitSearchContainer button:last-child{
  border-left: 1px solid #dee2e6;
}

#warningLimitSearch{
  font-size: 0.9rem;
  color: #ff8800;
}

</style>
